import React, { createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
const scrollToPricing = () => {
  const pricingSection = document.getElementById('pricing');
  if (pricingSection) {
    pricingSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
const redirectToCheckout = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
  // Fire Meta Pixel AddToCart event
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'AddToCart');
    } catch (error) {
      console.error('Meta Pixel error:', error);
    }
  }
  // Multiple redirect attempts for maximum compatibility
  const url = 'https://instaflowdp.com/cart/62947483746673:1';
  // Method 1: Direct assignment
  try {
    window.location.href = url;
  } catch (error) {
    // Method 2: Replace if assignment fails
    try {
      window.location.replace(url);
    } catch (error2) {
      // Method 3: Create and click link as last resort
      const link = document.createElement('a');
      link.href = url;
      link.click();
    }
  }
};
export function FinalCTA() {
  return <section className="py-12 relative overflow-hidden bg-aged-green" data-id="element-26">
      {/* Subtle vignette effect */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-black/20 pointer-events-none" data-id="element-27" />

      {/* Decorative Background Elements with golden sparkles */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-28">
        {/* Golden shimmer effects */}
        <motion.div animate={{
        y: [0, -30, 0],
        rotate: [0, 10, 0],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-[5%] left-[5%] w-72 h-72 bg-yellow-400 rounded-full mix-blend-screen opacity-20 blur-3xl" data-id="element-29" />
        <motion.div animate={{
        y: [0, 40, 0],
        rotate: [0, -10, 0],
        opacity: [0.15, 0.3, 0.15]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-[10%] right-[5%] w-96 h-96 bg-yellow-500 rounded-full mix-blend-screen opacity-15 blur-3xl" data-id="element-30" />

        {/* Additional golden sparkle spots */}
        <motion.div animate={{
        opacity: [0.3, 0.6, 0.3],
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} className="absolute top-[40%] right-[20%] w-32 h-32 bg-yellow-300 rounded-full mix-blend-screen opacity-25 blur-2xl" data-id="element-31" />
        <motion.div animate={{
        opacity: [0.2, 0.5, 0.2],
        scale: [1, 1.3, 1]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} className="absolute bottom-[30%] left-[15%] w-40 h-40 bg-yellow-400 rounded-full mix-blend-screen opacity-20 blur-2xl" data-id="element-32" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-33">
        <div className="max-w-3xl mx-auto text-center text-white" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-35">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 drop-shadow-sm flex flex-wrap items-center justify-center gap-3" data-id="element-36">
              <span className="text-white" data-id="element-37">Estás a una decisión</span>
              <Sparkles size={40} className="text-yellow-300 hidden md:inline-block" data-id="element-38" />
              <span className="text-[#f4c430] italic" data-id="element-39">de empezar distinto</span>
              <Sparkles size={40} className="text-yellow-300 hidden md:inline-block" data-id="element-40" />
            </h2>
            <p className="text-xl md:text-2xl mb-4 opacity-90 font-medium" data-id="element-41">
              No prometas que "el próximo mes" será mejor. Haz que lo sea.
            </p>
            <p className="text-lg md:text-xl mb-10 opacity-90" data-id="element-42">
              Empieza con un sistema que puedas mantener. Que se adapte a ti.
              Que te devuelva tranquilidad.
            </p>

            <div className="space-y-4 mb-10" data-id="element-43">
              <a href="https://instaflowdp.com/cart/62947483746673:1" target="_blank" rel="noopener noreferrer" onClick={e => {
              // Fire Meta Pixel AddToCart event before navigation
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'AddToCart');
              }
            }} className="relative inline-block px-10 py-4 text-lg font-extrabold text-black bg-gradient-to-b from-[#f4c430] via-[#f4c430] to-[#d4a420] rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto text-center" style={{
              boxShadow: '0 8px 0 0 rgba(180, 140, 30, 0.8), 0 12px 24px rgba(0, 0, 0, 0.4)'
            }} data-id="element-44">
                Descubre El Milagro del Sobre ahora
              </a>
              <div className="flex flex-col gap-3 text-sm md:text-base opacity-90" data-id="element-45">
                <p data-id="element-46">👉 Empieza a sentir control desde tu próxima quincena</p>
                <p data-id="element-47">👉 Deja de vivir al día y empieza a decidir con claridad</p>
                <p data-id="element-48">👉 El sistema que TikTok no te explicó completo</p>
                <p className="font-bold text-yellow text-lg" data-id="element-49">
                  👉 La quincena no debería doler. Cámbiala hoy
                </p>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 max-w-2xl mx-auto" data-id="element-50">
              <p className="text-lg italic mb-2" data-id="element-51">
                Si llegaste hasta aquí, no es casualidad.
              </p>
              <p className="text-xl font-bold" data-id="element-52">
                Tu relación con el dinero puede ser distinta.
              </p>
              <p className="text-2xl font-bold text-yellow mt-2" data-id="element-53">
                Y empieza ahora.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}